import { MicroMoments } from '../models/micro-moments.interfaces';

export const InternationalMedallionQualificationDollarsMocks: MicroMoments = {
  id: '',
  title: 'International Currency Conversion',
  description:
    'Your spending is automatically converted into Medallion Qualifying Dollars (MQDs) based on currency exchange rates.',
  action: {
    label: 'How Is My Currency Converted',
    url: 'NOT SURE FOR PATH AT THE MOMENT'
  },
  logo: {
    src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/moments/award-travel-mqd.svg',
    alt: 'Award Travel'
  },
  close: {
    path: '#',
    alt: 'close'
  },
  ariaLabel: {
    close: 'Close Micromoment'
  },
  disabled: false,
  loaded: true
};
